export default "__VITE_ASSET__Cltx89wP__"